import PropTypes from 'prop-types';
import React from 'react';

// material-ui
import { useTheme } from '@material-ui/styles';
import { Box } from '@material-ui/core';

import imgMain from 'assets/images/auth/right-forgot.png';
// assets
// import AuthPattern from 'assets/images/auth/img-a2-grid.svg';
// import AuthPatternDark from 'assets/images/auth/img-a2-grid-dark.svg';

// ===========================|| BACKGROUND GRID PATTERN 2 ||=========================== //

const BackgroundPattern2 = ({ children }) => {
    const theme = useTheme();
    return (
        <Box
            component="span"
            sx={{
                display: 'flex',
                minHeight: '100%',
                height: '100vh',
                bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : '#fff',
                backgroundImage: theme.palette.mode === 'dark' ? `url(${imgMain})` : `url(${imgMain})`,
                position: 'absolute',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                overflow: 'hidden',
                m: '0 0 0 auto',
                p: '100px 0',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                '& > *': {
                    position: 'relative',
                    zIndex: 5
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1,
                    bottom: 0,
                    // bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.dark : theme.palette.primary.light,
                    // backgroundImage: 'linear-gradient(320.4deg, #F28F8F 7.46%, #40C877 100%)',
                    opacity: theme.palette.mode === 'dark' ? 0.85 : 0.9
                }
            }}
        >
            {children}
        </Box>
    );
};

BackgroundPattern2.propTypes = {
    children: PropTypes.node
};

export default BackgroundPattern2;
